import React, { useState, useEffect } from 'react'
//import { useNavigate } from 'react-router-dom'
import {
    clssInfo,
    GetAttendanceFinalized,
    Attendance,
    updateAttendance,
    DestroyAttendance,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    //getVthQuarter,
    //getVIthQuarter,
} from '../../Api'

import SelectorDate from '../../components/SelectorOnDate'

import {
    Container,
    List,
    ListChecked,
    Emp,
    //Matter,
    //DivInfo,
    Span,
    ContainerDivs,
    Btt02,
    DivInfoDate,
    ContainerStudent,
    DivButton,
    EditContainer,
    SpanChecked,
    DataSelected,
    BoxButton,
    BoxButtonEdit,
    //BoxButtonStatus,
    //EmpEdit
} from './style';

import {
} from '../../components/Inputs'
import LoadingSpinner from '../../components/LoadingFrequence'

const IndexAttendance = () => {

    //const navigate = useNavigate()
    //const [matter, setMatter] = useState([])
    //const [Namematter, setNameMatter] = useState([])
    const [open, setopen] = useState('aberto')
    //const [id_matter, setclickMatter] = useState([])
    const [id_class, setId_class] = useState([])
    const [id_teacher, setId_teacher] = useState('')
    const [stdt, setStdt] = useState([])
    const [checked, setChecked] = useState([])
    const [selectedDate, setSelectedDate] = useState('')
    const [day, setDay] = useState('')
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')
    const [namestudent, setNamestudent] = useState('')
    const [editingStudent, setEditingStudent] = useState(null); // Estado para aluno em edição
    const [editingStatus, setEditingStatus] = useState('');
    //const [Student, setStudent] = useState(null); // Estado para aluno em edição
    //const [Status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);

    const [attendanceList, setAttendanceList] = useState([]);
    const [RemoveAttendanceList, setRemoveAttendanceList] = useState([]);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const idTeacher = JSON.parse(localStorage.getItem("Id_employee") || '""'); // Remove aspas extras
            setId_teacher(idTeacher);
            const id_class = sessionStorage.getItem("class-info");
            //const Matter = sessionStorage.getItem("attendance_ idmatter");
            const selectedDate = sessionStorage.getItem("selectedDate");

            //const res = await GetInfoMyClass(id_class, JSON.parse(id_teacher));

            /*if (Matter) {
                setclickMatter(Matter);
            }*/
            if (selectedDate) {

                const Day = sessionStorage.getItem("day");
                const Month = sessionStorage.getItem("month");
                const Year = sessionStorage.getItem("year");

                setSelectedDate(selectedDate);
                setDay(JSON.parse(Day));
                setMonth(JSON.parse(Month));
                setYear(JSON.parse(Year));
            }

            // setId_teacher(idTeacher || "");
            setId_class(id_class);
            if (day && month && year && id_class && id_teacher) {

                console.log("Payload enviado para o backend:", {
                    month,
                    year,
                    day,
                    id_class,
                    id_teacher, // Deve ser string aqui
                });
                const resAtt = await GetAttendanceFinalized(month, year, day, id_class, id_teacher);
                console.log("resAtt", resAtt)
                const resClass = await clssInfo(id_class);
                const attRealized = await resAtt.data.data.map(res => res.id_student._id);
                const checkedStudent = await resAtt.data.data;
                const student = await resClass.data.data.find(res => res).id_student
                    .filter(studentId => !attRealized.includes(studentId._id))
                    .sort((a, b) => a.name.localeCompare(b.name)); // Ordena `stdt` em ordem alfabética

                setStdt(student);
                setChecked(checkedStudent.sort((a, b) => a.id_student.name.localeCompare(b.id_student.name))); // Ordena `checked` em ordem alfabética
            }

            setLoading(false);
        })();
    }, [day, id_teacher, month, year]);

    // Exemplo de como inicializar todos os alunos com "presença"
    useEffect(() => {
        const initialAttendanceList = stdt.map(stdt => ({
            id_student: stdt._id,
            status: "P", // Marca todos os alunos como presença inicialmente
            day: day,
            month: month,
            year: year,
            id_teacher: id_teacher,
            id_class: id_class
        }));
        setAttendanceList(initialAttendanceList);
    }, [stdt,
        day,
        month,
        year,
        id_teacher,
        id_class,
    ]); // Isso assume que você tem a lista de alunos em "students"

    if (selectedDate) {
        sessionStorage.setItem("selectedDate", selectedDate)
        sessionStorage.setItem("day", day)
        sessionStorage.setItem("month", month)
        sessionStorage.setItem("year", year)

        const fetchQuarters = async () => {
            const idSchool = sessionStorage.getItem("id-school");

            const dateSelected = new Date(year, month - 1, day);

            const IstQuarter = await getIstQuarter(year, JSON.parse(idSchool))
            const IIndQuarter = await getIIndQuarter(year, JSON.parse(idSchool))
            const IIIrdQuarter = await getIIIrdQuarter(year, JSON.parse(idSchool))
            const IVthQuarter = await getIVthQuarter(year, JSON.parse(idSchool))
            //const VthQuarter = await getVthQuarter(year, JSON.parse(idSchool))
            //const VIthQuarter = await getVIthQuarter(year, JSON.parse(idSchool))
            const getQuarterStatus = (quarterData) => {
                return quarterData.data.data
                    .map((res) => {
                        const startDate = new Date(res.startyear, res.startmonth - 1, res.startday);
                        const endDate = new Date(res.endyear, res.endmonth - 1, res.endday);
                        if (dateSelected >= startDate && dateSelected <= endDate) {
                            return res.statusSupervisor;
                        }
                        return null;
                    })
                    .find((res) => res); // Retorna o primeiro status válido encontrado
            };

            const dataIstQuarter = getQuarterStatus(IstQuarter);
            const dataIIndQuarter = getQuarterStatus(IIndQuarter);
            const dataIIIrdQuarter = getQuarterStatus(IIIrdQuarter);
            const dataIVthQuarter = getQuarterStatus(IVthQuarter);

            // Retorna os dados encontrados em um objeto
            return {
                IstQuarter: dataIstQuarter || null,
                IIndQuarter: dataIIndQuarter || null,
                IIIrdQuarter: dataIIIrdQuarter || null,
                IVthQuarter: dataIVthQuarter || null,
            };
        };
        // Chamando a função e lidando com o resultado
        fetchQuarters().then((result) => {
            if (result.IstQuarter) {
                console.log("dataIstQuarter", result.IstQuarter);
                setopen(result.IstQuarter)
            }
            if (result.IIndQuarter) {
                console.log("dataIIndQuarter", result.IIndQuarter);
                setopen(result.IIndQuarter)
            }
            if (result.IIIrdQuarter) {
                console.log("dataIIIrdQuarter", result.IIIrdQuarter);
                setopen(result.IIIrdQuarter)
            }
            if (result.IVthQuarter) {
                console.log("dataIVthQuarter", result.IVthQuarter);
                setopen(result.IVthQuarter)
            }
        })
        fetchQuarters();
    }
    const clickRemovedate = () => {
        setLoading(true)
        sessionStorage.removeItem("selectedDate")
        sessionStorage.removeItem("day")
        sessionStorage.removeItem("month")
        sessionStorage.removeItem("year")

        setSelectedDate('')
        setDay('')
        setMonth('')
        setYear('')
        setLoading(false)
    }
    const Finalyze = async () => {
        setLoading(true)
        const res = await Attendance(attendanceList)
        if (res) {
            console.log("resattendance", res)
            window.location.reload()
        } else {
            console.log("resattendance erro", res)
            window.location.reload()
        }
    }

    const handleCheckAttendance = (id_student, status) => {
        setAttendanceList(prevList => {
            const existing = prevList.find(att => att.id_student === id_student);

            // Se já existe um registro e clicou no mesmo status, remove a marcação
            if (existing?.status === status) {
                return prevList.filter(att => att.id_student !== id_student);
            }

            // Atualiza a lista, garantindo que o aluno tenha apenas um status ativo
            return [
                ...prevList.filter(att => att.id_student !== id_student),
                { id_student, status, day, month, year, id_teacher, id_class }
            ];
        });
    };

    const startEditing = (checkedStdt) => {
        setEditingStudent(checkedStdt._id);
        setEditingStatus(checkedStdt.status);
        setNamestudent(checkedStdt)
    };
    const saveEdit = async () => {
        setLoading(true)
        await updateAttendance(editingStudent, editingStatus)
        window.location.reload()
        //setLoading(false)
    };

    const handleDestroy = (checked) => {
        const attendanceIds = checked.map(stdt => stdt._id); // Extrai somente os _id

        setRemoveAttendanceList(attendanceIds); // Armazena apenas os _id no estado
    };

    const Destroy = async () => {
        setLoading(true);
        const res = await DestroyAttendance(RemoveAttendanceList)
        if (res) {
            console.log("res", res)
            window.location.reload()
        }
    };

    //console.log("checked", checked)
    //console.log("RemoveAttendanceList", RemoveAttendanceList)
    //console.log("attendanceList", attendanceList)
    //console.log("matter", id_matter)
    /*console.log("day", day)
    console.log("month", month)
    console.log("year", year)
    console.log("stdt", stdt)
    console.log("open", open)
    console.log("Status", Status)*/

    return (
        <Container>
            {loading ?
                <LoadingSpinner />
                :
                <ContainerDivs>
                    {
                        !selectedDate
                        &&
                        <DivInfoDate>
                            <h3>Selecione a Data</h3>
                            <SelectorDate
                                setDay={setDay}
                                setMonth={setMonth}
                                setYear={setYear}
                                setSelectedDate={setSelectedDate}
                            />
                        </DivInfoDate>
                    }
                    {
                        selectedDate && !editingStudent && RemoveAttendanceList.length === 0
                        && (
                            open === 'aberto' ? (
                                <ContainerStudent>
                                    <h2>Chamada test</h2>
                                    <DataSelected>
                                        {/*<p>Disciplina: {Namematter}</p>*/}
                                        <p style={{ color: "#158fa2" }}>Data: {day}/{month}/{year}</p>
                                    </DataSelected>
                                    <DivButton>
                                        
                                        <Btt02 onClick={clickRemovedate}>
                                            Selecionar outra data
                                        </Btt02>
                                    </DivButton>
                                    {checked.length === 0 && RemoveAttendanceList.length === 0 &&
                                        <List>

                                            {
                                                stdt
                                                    .sort((a, b) => a.name.localeCompare(b.name)) // Ordena em ordem alfabética
                                                    .map(stdt => {
                                                        const attendance = attendanceList.find(att => att.id_student === stdt._id);
                                                        const isPresent = attendance?.status === "P";
                                                        const isAbsent = attendance?.status === "F";

                                                        return (
                                                            <Emp key={stdt._id}>
                                                                <Span>{stdt.name}</Span>
                                                                <BoxButton>
                                                                    <label style={{ color: isPresent ? "green" : "black" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isPresent}
                                                                            onChange={() => handleCheckAttendance(stdt._id, "P")}
                                                                        />
                                                                        Presença
                                                                    </label>
                                                                    <label style={{ color: isAbsent ? "red" : "black" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isAbsent}
                                                                            onChange={() => handleCheckAttendance(stdt._id, "F")}
                                                                        />
                                                                        Ausência
                                                                    </label>
                                                                </BoxButton>
                                                            </Emp>

                                                        );
                                                    })
                                            }
                                            <Btt02 onClick={Finalyze}>
                                                Finalizar Chamada
                                            </Btt02>
                                        </List>
                                    }
                                    {stdt.length === 0 && RemoveAttendanceList.length === 0 &&
                                        <ListChecked>
                                            {checked
                                                .sort((a, b) => a.id_student.name.localeCompare(b.id_student.name)) // Ordena em ordem alfabética
                                                .map(checkedStdt => (
                                                    <Emp key={checkedStdt._id}>
                                                        <SpanChecked>{checkedStdt.id_student.name}</SpanChecked>

                                                        <BoxButton>
                                                            <Btt02 style={{
                                                                backgroundColor: checkedStdt.status === 'P' ? 'green' : 'red'
                                                            }}>
                                                                {checkedStdt.status}
                                                            </Btt02>

                                                            <Btt02 onClick={() => startEditing(checkedStdt)} style={{ backgroundColor: 'blue' }}>
                                                                Editar
                                                            </Btt02>
                                                        </BoxButton>
                                                    </Emp>
                                                ))}
                                            <Btt02 onClick={() => handleDestroy(checked)}>
                                                Apagar Chamada
                                            </Btt02>
                                        </ListChecked>
                                    }
                                </ContainerStudent>
                            ) : (
                                <>
                                    <h3> Bimestre fechado, para editar contate o Diretor ou Supervisor.</h3>

                                    <DivButton>
                                        {/* <Btt02 onClick={clickRemovematter}>
                                    Selecionar outra materia
                                </Btt02>*/}
                                        <Btt02 onClick={clickRemovedate}>
                                            Selecionar outra data
                                        </Btt02>
                                    </DivButton>
                                </>
                            )
                        )}
                    {editingStudent && (
                        <EditContainer>
                            <h3>Editando Frequencia de {namestudent.id_student.name}</h3>
                            {console.log("editingStudent", namestudent.id_student.name)}
                            <select
                                value={editingStatus}
                                onChange={(e) => setEditingStatus(e.target.value)}
                            >
                                <option value="P">Presença</option>
                                <option value="F">Ausência</option>
                            </select>
                            <BoxButtonEdit>
                                <Btt02 onClick={saveEdit}>Salvar</Btt02>
                                <Btt02 onClick={() => setEditingStudent(null)}>Cancelar</Btt02>
                            </BoxButtonEdit>

                        </EditContainer>
                    )}
                    {RemoveAttendanceList.length > 0 && (
                        <EditContainer>
                            <h3>Tem certeza que deseja apagar a chamada</h3>
                            <BoxButtonEdit>
                                <Btt02 onClick={Destroy}>Apagar</Btt02>
                                <Btt02 onClick={() => setRemoveAttendanceList([])}>Cancelar</Btt02>
                            </BoxButtonEdit>

                        </EditContainer>
                    )}
                </ContainerDivs>
            }
        </Container>
    )
}

export default IndexAttendance